import React, { useState } from 'react'
import ReadMainSeries from './form/readMainSeries/ReadMainSeries'
import ReadNewSeries from './form/readNewSeries/ReadNewSeries'
import MyButton from '../UI/form/MyButton'
import { addGoodNewInBoxAPI } from '../../api/pack/seriesAPI'
import { responseError } from '../../helpers/response/ResponseHelper'

const AddGoodInPackForm = () => {

	const [goodDataMain, setGoodDataMain] = useState(null)
	const [goodDataNew, setGoodDataNew] = useState(null)

	const [success, setSuccess] = useState('')
	const [error, setError] = useState('')
	const [errorMain, setErrorMain] = useState('')
	const [loading, setLoading] = useState(false)

	const [reset, setReset] = useState(false)

	const add = () => {
		const data = {
			seriesMain: goodDataMain.seriesText ? goodDataMain.seriesText : goodDataMain.anotherSeries,
			series: goodDataNew.series,
			seriesId: goodDataNew.seriesId,
		}

		setLoading(true)
		setError('')
		setSuccess('')
		addGoodNewInBoxAPI(data).then(data => {
			setSuccess('Успішно додано товар в коробку')
			setLoading(false)
		}).catch(e => {
			setError(responseError(e))
			setLoading(false)
		})
		// console.log('goodDataMain.seriesText', goodDataMain.seriesText ? goodDataMain.seriesText : goodDataMain.anotherSeries)
		// console.log('goodDataNew', goodDataNew ? goodDataNew : goodDataNew)
		console.log('added', data)
	}

  return (
	<div className='myBlock__content'>
		<p>
			Для додавання нового товару (наприклад <b>"плата детонації"</b>) в потрібну коробку в партії 
			необхідно зчитати QR-код будь-якого іншого товару (дрона, котушки, батки) з <b>цієї самої коробки</b>
		</p>

		{
			goodDataMain || errorMain?
				<MyButton
					color='red'
					// onClick={reset}
					onClick={e => {
						setGoodDataMain(null)
						setGoodDataNew(null)
						setError('')
						setErrorMain('')
						setReset(true)
					}}
				>
					Сканувати новий товар
				</MyButton>
			: ''
		}

		<ReadMainSeries 
			goodData={goodDataMain}
			setGoodData={setGoodDataMain}
			reset={reset}
			setReset={setReset}
			errorMain={errorMain}
			setErrorMain={setErrorMain}
		/>

		{
			goodDataMain ?
				<ReadNewSeries 
					goodDataMain={goodDataMain}
					goodData={goodDataNew}
					setGoodData={setGoodDataNew}
					reset={reset}
					setReset={setReset}
				/>
			: ''
		}

		{
			success ?
				<div className='success'>
					{success}
				</div>
			: ''
		}

		{
			error ?
				<div className='error'>
					{error}
				</div>
			: ''
		}

		{
			goodDataMain && goodDataNew ?
				<MyButton
					onClick={add}
					disabled={loading ? true : false}
				>
					Додати новий товар в коробку
				</MyButton>
			: ''
		}
		
	</div>
  )
}

export default AddGoodInPackForm